import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsWorkflowsAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-workflows-associate',
	path: '/secure/project/SelectProjectWorkflowScheme!default.jspa',
};
